import React from "react";

function PaperClip({width="26px",height="26px",color="#7030A0"}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0" />

      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <g id="SVGRepo_iconCarrier">
        <path
          d="M9.00004 5H17C17.5523 5 18 5.44772 18 6V19C18 19.5523 17.5523 20 17 20H7.00004C6.44776 20 6.00004 19.5523 6.00004 19V11M9.00004 5L9 9C9 10.1046 8.10457 11 7 11C5.89543 11 5 10.1046 5 9V5M9.00004 5C9.00004 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5V9M11 9H15M10 12H15M9.00004 15H15"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

export default PaperClip;
